var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{ref:_vm.audioElementId,attrs:{"preload":"auto","src":_vm.src,"data-has-errors":Boolean(_vm.error)},on:{"error":_vm.audioErrorHandler,"canplaythrough":_vm.onAudioElementCanPlay}})
}
var staticRenderFns = []

export { render, staticRenderFns }